export default __webpack_public_path__ + "static/char-s-21-zh-Hans-937a8eca13de55b30cc77717aece107a.png";